import { render } from "./RenameFolder.vue?vue&type=template&id=0a47fb06"
import script from "./RenameFolder.vue?vue&type=script&lang=js"
export * from "./RenameFolder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Thanusan/My/TRAINN-Assignment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__